<app-si-dialog header="Save Changes" [preventClose]="true" modalFooterClasses="si-dialog__footer--centered" (close)="onConfirmation(false)">
    <ng-template appDialogBody>
        <div class="px-16 py-8">
            <div class="flex items-center gap-5">
                <fa-icon class="text-danger shrink-0 mt-0.5" [icon]="['fal', 'circle-exclamation']" size="2x"></fa-icon>
                <p class="m-0">It looks like you made changes on this page.  Would you like to save before navigating away?</p>
            </div>
        </div>
    </ng-template>
    <ng-template appDialogFooter>
        <button matButton="outlined" type="button" (click)="onConfirmation(false, false)">
            Cancel
        </button>
        <button matButton="filled" class="mat-error" type="submit" (click)="onConfirmation(true, false)">
            Proceed without saving
        </button>
        <button matButton="filled" type="submit" [disabled]="!(data.isValid$ | async)" (click)="onConfirmation(true, true)">
            Save
        </button>
    </ng-template>
</app-si-dialog>
